import jsPDF from 'jspdf';
import logo from '../../../../../../../style/img/logo_acciona.png';
import AccionaRegular from '../../../../../../../style/fonts/acciona-regular-normal';
import AccionaBold from '../../../../../../../style/fonts/acciona-medium-bold';
require('jspdf-autotable');

const cellStyle = {
  fillColor: 'rgb(230, 230, 230)',
  cellPadding: 4,
  halign: 'center',
  fontSize: 11,
  valign: 'middle',
  lineWidth: 1,
  lineColor: 'black',
  fontStyle: 'bold',
  font: 'AccionaBold',
};

const tableCellStyle = {
  fillColor: 'white',
  cellPadding: 4,
  halign: 'center',
  textColor: '#666666',
  fontSize: 10,
  valign: 'middle',
  lineWidth: 1,
  lineColor: 'black',
  font: 'AccionaRegular',
};

const nullValue = (value) => {
  if (value === null || value === 'null') {
    return 'Valor no registrado';
  } else {
    return value;
  }
};

const mashControl = (value) => {
  if (value === 1) return 'SI';
  return 'NO';
};

const showPageStatus = (doc) => {
  const currentPageInfo = doc.getCurrentPageInfo();
  doc.setFontSize(12);
  doc.text(`${currentPageInfo.pageNumber}/${doc.getNumberOfPages()}`, 400, 600);
};

const generatePDF = ({ formState, scannedDocket, photoDocket, fileName }) => {
  const doc = new jsPDF({
    unit: 'px',
  });
  const width = doc.internal.pageSize.getWidth();
  const height = doc.internal.pageSize.getHeight();

  doc.addFileToVFS('AccionaRegular.ttf', AccionaRegular);
  doc.addFileToVFS('AccionaBold.ttf', AccionaBold);
  doc.addFont('AccionaRegular.ttf', 'AccionaRegular', 'normal');
  doc.addFont('AccionaBold.ttf', 'AccionaBold', 'bold');

  doc.addImage(logo, 'png', 20, 10, 80, 38);
  doc.autoTable({
    body: [
      [{ content: 'Proveedor', colSpan: 6, styles: { ...cellStyle } }],
      [
        {
          content: nullValue(formState.supplier_id),
          colSpan: 6,
          styles: { ...tableCellStyle },
        },
      ],
      [
        {
          content: 'Albarán',
          colSpan: 2,
          styles: { ...cellStyle },
        },
        {
          content: 'Planta Hormigón',
          colSpan: 2,
          styles: { ...cellStyle },
        },
        {
          content: 'Fecha entrega',
          colSpan: 2,
          styles: { ...cellStyle },
        },
      ],
      [
        {
          content: nullValue(formState.docket_number),
          colSpan: 2,
          styles: { ...tableCellStyle },
        },
        {
          content: nullValue(formState.plant),
          colSpan: 2,
          styles: { ...tableCellStyle },
        },
        {
          content: nullValue(formState.arriving_date),
          colSpan: 2,
          styles: { ...tableCellStyle },
        },
      ],
      [
        {
          content: 'Tipo Hormigón',
          colSpan: 3,
          styles: { ...cellStyle },
        },
        {
          content: 'Cantidad hormigón [m3]',
          colSpan: 3,
          styles: { ...cellStyle },
        },
      ],
      [
        {
          content: nullValue(formState.recipe),
          colSpan: 3,
          styles: { ...tableCellStyle },
        },
        {
          content: nullValue(formState.delivered),
          colSpan: 3,
          styles: { ...tableCellStyle },
        },
      ],
      [
        {
          content: 'Peticionario',
          colSpan: 3,
          styles: { ...cellStyle },
        },
        {
          content: 'Lugar de suministro',
          colSpan: 3,
          styles: { ...cellStyle },
        },
      ],
      [
        {
          content: nullValue(formState.requester),
          colSpan: 3,
          styles: { ...tableCellStyle },
        },
        {
          content: nullValue(formState.ocr_destination),
          colSpan: 3,
          styles: { ...tableCellStyle },
        },
      ],
      [
        {
          content: 'Elementos hormigonados',
          colSpan: 6,
          styles: { ...cellStyle },
        },
      ],
      [
        {
          content: nullValue(formState.elements),
          colSpan: 6,
          styles: { ...tableCellStyle },
        },
      ],
      [
        {
          content: 'Situación de obra',
          colSpan: 6,
          styles: { ...cellStyle },
        },
      ],
      [
        {
          content: nullValue(formState.detailed_location),
          colSpan: 6,
          styles: { ...tableCellStyle },
        },
      ],
      [
        {
          content: 'Transportista obra',
          colSpan: 3,
          styles: { ...cellStyle },
        },
        {
          content: 'Tipo de cemento',
          colSpan: 3,
          styles: { ...cellStyle },
        },
      ],
      [
        {
          content: nullValue(formState.delivery_company),
          colSpan: 3,
          styles: { ...tableCellStyle },
        },
        {
          content: nullValue(formState.concrete_id),
          colSpan: 3,
          styles: { ...tableCellStyle },
        },
      ],
      [
        {
          content: 'Matrícula del camión',
          colSpan: 3,
          styles: { ...cellStyle },
        },
        {
          content: 'Cantidad cemento [Kg/m3]',
          colSpan: 3,
          styles: { ...cellStyle },
        },
      ],
      [
        {
          content: nullValue(formState.truck),
          colSpan: 3,
          styles: { ...tableCellStyle },
        },
        {
          content: nullValue(formState.compound),
          colSpan: 3,
          styles: { ...tableCellStyle },
        },
      ],
      [
        {
          content: 'Conductor camión',
          colSpan: 3,
          styles: { ...cellStyle },
        },
        {
          content: 'Relación A/C',
          colSpan: 3,
          styles: { ...cellStyle },
        },
      ],
      [
        {
          content: nullValue(formState.driver),
          colSpan: 3,
          styles: { ...tableCellStyle },
        },
        {
          content: nullValue(formState.relation_wc),
          colSpan: 3,
          styles: { ...tableCellStyle },
        },
      ],
      [
        {
          content: 'CIF transportista',
          colSpan: 3,
          styles: { ...cellStyle },
        },
        {
          content: 'Tipo aditivos',
          colSpan: 3,
          styles: { ...cellStyle },
        },
      ],
      [
        {
          content: nullValue(formState.delivery_company_cif),
          colSpan: 3,
          styles: { ...tableCellStyle },
        },
        {
          content: nullValue(formState.admixtures_id),
          colSpan: 3,
          styles: { ...tableCellStyle },
        },
      ],
      [
        {
          content: 'Hora fabricación',
          colSpan: 3,
          styles: { ...cellStyle },
        },
        {
          content: 'Cantidad aditivos [l/m3]',
          colSpan: 3,
          styles: { ...cellStyle },
        },
      ],
      [
        {
          content: nullValue(formState.manufacture_time),
          colSpan: 3,
          styles: { ...tableCellStyle },
        },
        {
          content: nullValue(formState.admixtures_quantity),
          colSpan: 3,
          styles: { ...tableCellStyle },
        },
      ],
      [
        {
          content: 'Hora entrega',
          colSpan: 3,
          styles: { ...cellStyle },
        },
        {
          content: 'Adiciones hormigón obra',
          colSpan: 3,
          styles: { ...cellStyle },
        },
      ],
      [
        {
          content: nullValue(formState.arriving_time),
          colSpan: 3,
          styles: { ...tableCellStyle },
        },
        {
          content: nullValue(formState.admixtures_extra),
          colSpan: 3,
          styles: { ...tableCellStyle },
        },
      ],
      [
        {
          content: 'Hora de inicio de descarga',
          colSpan: 3,
          styles: { ...cellStyle },
        },
        {
          content: 'Hora de fin de descarga',
          colSpan: 3,
          styles: { ...cellStyle },
        },
      ],
      [
        {
          content: nullValue(formState.start_discharging_time),
          colSpan: 3,
          styles: { ...tableCellStyle },
        },
        {
          content: nullValue(formState.finish_discharging_time),
          colSpan: 3,
          styles: { ...tableCellStyle },
        },
      ],
      [
        {
          content: 'Hora límite uso',
          colSpan: 6,
          styles: { ...cellStyle },
        },
      ],
      [
        {
          content: nullValue(formState.limit_time),
          colSpan: 6,
          styles: { ...tableCellStyle },
        },
      ],
      [
        {
          content: 'Amasada de control',
          colSpan: 2,
          styles: { ...cellStyle },
        },
        {
          content: 'Número de probetas',
          colSpan: 2,
          styles: { ...cellStyle },
        },
        {
          content: 'Asentamiento cono [cm]',
          colSpan: 2,
          styles: { ...cellStyle },
        },
      ],
      [
        {
          content: mashControl(formState.mash_control),
          colSpan: 2,
          styles: { ...tableCellStyle },
        },
        {
          content: nullValue(formState.specimens_number),
          colSpan: 2,
          styles: { ...tableCellStyle },
        },
        {
          content: nullValue(formState.slump),
          colSpan: 2,
          styles: { ...tableCellStyle },
        },
      ],
    ],
    margin: { top: 45 },
    useCss: true,
  });
  showPageStatus(doc);

  if (scannedDocket) {
    doc.addPage();
    doc.addImage(logo, 'png', 20, 10, 80, 38);
    doc.addImage(scannedDocket, 'jpeg', 20, 50, width - 40, height - 120);
    showPageStatus(doc);
  }

  if (photoDocket) {
    doc.addPage();
    doc.addImage(logo, 'png', 20, 10, 80, 38);
    doc.addImage(photoDocket, 'jpeg', 20, 50, width - 40, height - 120);
    showPageStatus(doc);
  }

  doc.save(fileName + '.pdf');
};

export default generatePDF;
